import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { ICompanyAuditDetailsModel } from 'app/company-audit/models/company-audit-details.model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { SharedService } from 'app/shared/services/shared.service';
import { debounceTime } from 'rxjs/operators';
import { AccountService } from 'app/core/services/account.service';
import { CompanyAuditService } from 'app/company-audit/services/company-audit.service';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { User } from 'app/shared/models/User';

@Component({
  selector: 'app-company-audit-list',
  templateUrl: './company-audit-list.component.html',
  styleUrls: ['./company-audit-list.component.css']
})
export class CompanyAuditListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    audits: ICompanyAuditDetailsModel[] = [];
    auditList: ICompanyAuditDetailsModel[] = [];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;
    companyUserList: CompanyUserModel[];
    companyId: string;
    auditId: string;
    user: User;

    constructor(
        private _sharedService: SharedService,
        private _companyAuditService: CompanyAuditService,
        private fb: FormBuilder,
        private _sortService: SortService
    ) { }

    ngOnInit() {

        this.headerTitle = { title: 'Audits' }

        this._sharedService.currentUser.subscribe(user => {
            this.user = user;
        });

        this._sharedService.currentCompanyUser.subscribe(companyUser => {
            if(companyUser) {
                this.companyUserList = companyUser;
                this.audits = [];
                this.auditList = [];
                this.companyUserList.forEach(x => {
                    if (x.siteUserId) {
                        this._companyAuditService.getAll(x.companyId).subscribe(
                            audits => {
                                this.audits = this.audits.concat(audits);
                                this.auditList = this.auditList.concat(audits);
                            },
                            error => this.errors = error.errorList
                        );
                    }
                })
                this.auditList.sort(compareValues('startDate', 'asc'));
            }
        });

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.auditList = this._sortService.filterAndSortlist(this.audits, newValue, this.lastSort);
        });

        function compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                    // property doesn't exist on either object
                    return 0;
                }

                const varA = (typeof a[key] === 'string')
                    ? a[key].toUpperCase() : a[key];
                const varB = (typeof b[key] === 'string')
                    ? b[key].toUpperCase() : b[key];

                let comparison = 0;
                if (varA > varB) {
                    comparison = 1;
                } else if (varA < varB) {
                    comparison = -1;
                }
                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        }
  }

}
